import { useQuery } from "react-query";
import axios from "../axios";

const useGetCharities = () => {
  const query = useQuery(
    "charities",
    async () => {
      try {
        return await axios.get("/api/charity");
      } catch (error) {
        console.log(error);
      }
    },
    {
      staleTime: 30000,
    }
  );

  return query;
};

export default useGetCharities;
